module.exports = __webpack_public_path__ + "img/工艺花架-1.807910c5.jpg";